<template>
  <main class="section">
    <div class="container">
      <div class="columns" v-if="title">
        <div class="column">
          <h3 class="title is-4">{{ title }}</h3>
        </div>
      </div>
      <DataObject
        :singleIndicator="singleIndicator"
        :codeHandle="codeHandle"
        :codes="codes"
        :variables="variables"
        :defaultType="'chart'"
        :availableTypes="['chart']"
        class="m-b-xl"
      ></DataObject>
    </div>
  </main>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  components: {
    DataObject: () => import(/* webpackChunkName: "DataObject" */ '@/components/shared/DataObject')
  },

  metaInfo() {
    return {
      title: this.title
    };
  },

  data() {
    return {
      title: 'Конструктор чартов',
      singleIndicator: true,
      codeHandle: {},
      codes: [],
      variables: []
    };
  }
};
</script>
